const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M19.6,12.6H8.4C7.6,12.6,7,12,7,11.2s0.6-1.4,1.4-1.4h11.2c0.8,0,1.4,0.6,1.4,1.4S20.4,12.6,19.6,12.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M19.6,18.2H8.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h11.2c0.8,0,1.4,0.6,1.4,1.4 C21,17.6,20.4,18.2,19.6,18.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M14,28H1.4c-0.5,0-0.9-0.2-1.2-0.6C0,27-0.1,26.5,0.1,26c1-2.4,1.6-5.2,1.3-5.8c-1-1.9-1.5-4-1.5-6.2 C0,6.3,6.3,0,14,0s14,6.3,14,14S21.7,28,14,28z M3.4,25.2H14c6.2,0,11.2-5,11.2-11.2S20.2,2.8,14,2.8S2.8,7.8,2.8,14 c0,1.7,0.4,3.4,1.2,5C4.7,20.5,4.1,23.2,3.4,25.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.c2b50c32c5aae2846d08d17826fa3f0c.svg";
export { ForwardRef as ReactComponent };